import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { OfferSelectionCardModel } from '@flocasts/experience-service-types'

@Component({
  selector: 'flo-plans-promo-section',
  templateUrl: './plans-promo-section.component.html',
  styleUrls: ['./plans-promo-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlansPromoSectionComponent {
  @Input()
  offers: OfferSelectionCardModel[]
  @Input()
  isPlansVariation = true
  @Input()
  sportName: string
  @Output()
  offerSelected = new EventEmitter<OfferSelectionCardModel>()
  @Output()
  signupSelected = new EventEmitter<void>()

  onOfferSelected(offer: OfferSelectionCardModel): void {
    this.offerSelected.emit(offer)
  }

  onSignupSelected(): void {
    this.signupSelected.emit()
  }
}
